import axiosInst from "api/config/axiosConfig";
import { showError } from "utils/notifications";
import { DeviceDataTypes } from "./device-lookup.config";

export interface OrganizationDeviceLookupResponse {
  devices: DeviceDataTypes[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const getDevicesByOrganization = async (organization: string, page: number, pageSize: number) => {
  const response = await axiosInst.get<OrganizationDeviceLookupResponse>("/beta/appSystemInfo", {
    params: { orglookup: organization, page, pageSize },
  });
  if (!Array.isArray(response.data?.devices) || !Number.isInteger(response.data.totalCount)) {
    showError("Organization lookup is unavailable. Please try again later.");
    throw new Error("Invalid organization device lookup response");
  }
  return response.data;
};

export const getDeviceBySerial = async (data: string) => {
  const response = await axiosInst.get(`/beta/appSystemInfo?snlookup=${data}`);
  if (!response.data) {
    showError("Incorrect Serial Number");
    throw new Error("Incorrect Serial Number");
  }
  return response.data;
};

export const getDeviceByImei = async (data: string) => {
  const response = await axiosInst.get(`/beta/appSystemInfo?imeilookup=${data}`);
  if (!response.data) {
    showError("Incorrect IMEI Number");
    throw new Error("Incorrect IMEI Number");
  }
  return response.data;
};
